import { render, staticRenderFns } from "./BeneficiariesTable.vue?vue&type=template&id=9fc459c0&scoped=true&"
import script from "./BeneficiariesTable.vue?vue&type=script&lang=js&"
export * from "./BeneficiariesTable.vue?vue&type=script&lang=js&"
import style0 from "./BeneficiariesTable.vue?vue&type=style&index=0&id=9fc459c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fc459c0",
  null
  
)

export default component.exports